export default function gt(value, { minLength, string = true, locale = {} }) {
  if (!string && value.toString().trim().length < minLength) {
    return locale.minLength || `Minimum of ${minLength} character required`;
  }

  if (string && value.length < minLength) {
    return locale.minLength || `Minimum of ${minLength} character required`;
  }

  return null;
}
